export default __webpack_public_path__ + "static/media/complete.f764d465.svg";